import { useMemo } from 'react';
import ReactSelect from 'react-select';
import type { SelectOption } from './Select';
import { selectStyles } from './selectStyles';

type Props<O extends SelectOption<number>> = {
  value: O[];
  onChange: (options: O[]) => void;
  options: O[];
  placeholder?: string;
  isDisabled?: boolean;
  noOptionsMessage?: string;
};

function GroupTagSelect<O extends SelectOption<number>>({
  value,
  onChange,
  options,
  placeholder = 'Add groups…',
  isDisabled = false,
  noOptionsMessage = 'No active groups',
}: Props<O>) {
  const styles = useMemo(() => selectStyles<O, true>({ isDisabled }), [isDisabled]);

  return (
    <ReactSelect<O, true>
      isMulti
      value={value}
      onChange={(next) => onChange(next ? [...next] : [])}
      options={options}
      placeholder={placeholder}
      isDisabled={isDisabled}
      styles={styles}
      menuPortalTarget={document.body}
      noOptionsMessage={() => noOptionsMessage}
      closeMenuOnSelect={false}
    />
  );
}

export default GroupTagSelect;
